import React from 'react';
import IconWrapper from '../IconWrapper';
const PlayVideoIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props),
    React.createElement("path", { d: "M16.14 9.99c.475.281.48.735 0 1.02L1.86 19.49c-.475.281-.86.06-.86-.485V1.995c0-.55.38-.77.86-.484l14.28 8.478z" })));
export default PlayVideoIcon;
//# sourceMappingURL=PlayVideoIcon.js.map